<script setup>
import { reactive, onMounted, onUpdated, ref } from 'vue'
import { Link } from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Icons/Logo'

const props = defineProps({
  category: String,
  title: String,
  slug: String,
})

const state = reactive({
  text: '',
  url: '',
})

const homeRef = ref()
const categoryRef = ref()
const titleRef = ref()
const mainRef = ref()
const breadcrumbsRef = ref()

const setTextAndUrl = () => {
  if (props.category === 'news') {
    state.text = 'ニュース'
    state.url = '/news'
    return
  }
  if (props.category === 'brand') {
    state.text = 'ブランド'
    state.url = '/brands'
    return
  }
  if (props.category === 'story') {
    state.text = 'ブランドストーリー'
    state.url = '/brandstory'
    return
  }
  if (props.category === 'shop') {
    state.text = 'A&F店舗一覧'
    state.url = '/stores'
    return
  }
  if (props.category === 'book') {
    state.text = 'A&Fブックス'
    state.url = '/books'
    return
  }
}
onMounted(() => {
  setTextAndUrl()
})

onUpdated(() => {
  mainRef.value = document.querySelector('.detail-contents .main')
  if(mainRef.value){
    const targetW = mainRef.value.clientWidth - (homeRef.value.clientWidth + categoryRef.value.clientWidth) + 'px'
    titleRef.value.style.width = targetW
  }else{
    const targetW = breadcrumbsRef.value.clientWidth - (homeRef.value.clientWidth + categoryRef.value.clientWidth) + 'px'
    titleRef.value.style.width = targetW
  }
})
</script>

<template>
  <ul ref="breadcrumbsRef" class="hidden sm:flex items-center max-w-[850px] mx-auto mb-[30px] [&>li]:h-[20px] [&>li]:flex [&>li]:items-center">
    <li ref="homeRef">
      <Link href="/" class="relative inline-block h-[15px] [&_svg]:h-full [&_svg]:w-auto"><Logo type="icon" /></Link>
      <span class="arrow-right mx-[10px] !translate-y-[1px] !w-[7px] !h-[7px] !border-t-[2px] !border-r-[2px]" />
    </li>
    <li ref="categoryRef">
      <Link :href="state.url" class="inline-block whitespace-nowrap">{{ state.text }}</Link>
      <span class="arrow-right ml-[10px] mr-[13px] !translate-y-[1px] !w-[7px] !h-[7px] !border-t-[2px] !border-r-[2px]" />
    </li>
    <li>
      <div ref="titleRef" class="whitespace-nowrap overflow-hidden text-ellipsis [-webkit-text-overflow: ellipsis] [-o-text-overflow]">
        <template v-if="props.slug">
          <Link :href="`${state.url}/${props.slug}`" class="">{{ props.title }}</Link>
        </template>
        <template v-else>
          {{ props.title }}
        </template>
      </div>
    </li>
  </ul>
</template>
